//DNA
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVvGBFTEGBXBCZ": // Dev Baac BO EP
    case "PVHmKpMQpQxLOP": // Prod Baac BO EP
      switch (decodeToken()?.sub) {
        case "ID_yQ2qYxklHQR8": //prod sopapan.ma@baac.or.th
        case "ID_4pW0G8xjkhDE": //prod Nida.ng@baac.or.th
        case "ID_whW8ss4pPOqZ": //prod akewit.ta@baac.or.th
        case "ID_NSdlGwXBPoMD": //prod Janjira.th@baac.or.th
        case "ID_SOgVE8rIxBVh": //prod suparuk.ta@baac.or.th
        case "ID_qFIAxN8K3U80": //prod sirapach.ru@baac.or.th
          return [...report];
      }
    default:
      return [
        ...inventory,
        ...privileges,
        ...banner,
        ...fulfillment,
        ...document,
        ...report,
        ...dataManagement,
      ];
  }
};

export default renderNavByPermission();
